import { TableRows } from 'ui/tableRows';
import { createTableRow } from 'modules/anonymousUserTracking/utils';
import { useCriteriaIndexQueryContext } from 'modules/anonymousUserTracking/context/CriteriaIndexQueryContext';
import { AnonUserCriteria } from 'modules/graphql/types/GraphQLAnonymousCriteria';
import { TableHeaderProps } from 'ui/tableHeader';
import { Spinner } from 'ui/spinner';
import { CriteriaTableTab } from 'modules/anonymousUserTracking/types';
import { PAGE_SIZES, PaginationUpdateEvent } from 'ui/paginationFooter';
import { TABLE_COLUMNS } from '../../constants';
import {
  ExpandingWrapper,
  StyledPaginationFooter,
  StyledTable,
  StyledTableHeader,
} from '../AnonymousUserTracking.styled';
import { EmptyState } from './EmptyState';

export const AnonymousCriteriaTable = ({
  setIsArchivalModalOpen,
  setIsToggleActiveModalOpen,
  setActionModalCriteria,
}: {
  setIsArchivalModalOpen: (open: boolean) => void;
  setIsToggleActiveModalOpen: (open: boolean) => void;
  setActionModalCriteria: (criteria: AnonUserCriteria) => void;
}) => {
  const {
    stateFilterTab,
    searchTextQuery,
    sortedBy,
    setSortedBy,
    sortDirection,
    setSortDirection,
    pageNum,
    setPageNum,
    pageSize,
    setPageSize,
    criterias,
    criteriasLoading,
    totalCriteriaCount,
  } = useCriteriaIndexQueryContext();

  const rows = criterias.map((criteria: AnonUserCriteria) =>
    createTableRow(
      criteria,
      setIsArchivalModalOpen,
      setIsToggleActiveModalOpen,
      setActionModalCriteria,
    ),
  );

  const filterApplied = stateFilterTab !== CriteriaTableTab.ALL || !!searchTextQuery;
  const shouldShowTableContent = !!criterias?.length && !criteriasLoading;
  const shouldShowEmptyState = !criterias?.length && !criteriasLoading;

  const handlePaginationUpdate = (update: PaginationUpdateEvent) => {
    setPageNum(update.page);
    setPageSize(update.pageSize);
  };

  return (
    <>
      <StyledTable data-test="anonymous-criteria-table">
        <StyledTableHeader
          columns={TABLE_COLUMNS}
          sortedBy={sortedBy}
          setSortedBy={setSortedBy as TableHeaderProps['setSortedBy']}
          sortDirection={sortDirection}
          setSortDirection={setSortDirection as TableHeaderProps['setSortDirection']}
        />
        {shouldShowTableContent && <TableRows columns={TABLE_COLUMNS} rows={rows} />}
      </StyledTable>
      {shouldShowEmptyState && <EmptyState filterApplied={filterApplied} />}
      {criteriasLoading && (
        <ExpandingWrapper>
          <Spinner />
        </ExpandingWrapper>
      )}
      {shouldShowTableContent && (
        <StyledPaginationFooter
          currentPage={pageNum}
          itemsPerPage={pageSize}
          pageSizes={PAGE_SIZES}
          onUpdate={handlePaginationUpdate}
          numItems={totalCriteriaCount}
        />
      )}
    </>
  );
};
